"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateBMP = exports.isBMP = void 0;
function isBMP(buffer) {
  return 'BM' === buffer.toString('ascii', 0, 2);
}
exports.isBMP = isBMP;
function calculateBMP(buffer) {
  return {
    width: buffer.readUInt32LE(18),
    height: Math.abs(buffer.readInt32LE(22))
  };
}
exports.calculateBMP = calculateBMP;